import React, { FC } from 'react';
import { useUserContext } from '../UserContext';
import LanguageSetter from './LanguageSetter';

const AuthLanguageSetter: FC = ({ children }) => {
  const { isAuthenticated, myAccount } = useUserContext();

  return (
    <LanguageSetter authenticated loaded={isAuthenticated} acctLng={myAccount?.language}>
      {children}
    </LanguageSetter>
  );
};

export default AuthLanguageSetter;
